<template>
  <b-card>
    <layout-loading v-if="itemLoading" />
    <b-form>
      <b-row>
        <b-col md="6">
          <b-form-group
            :label="$t('general.title')"
            label-for="FAQ-category-title"
          >
            <b-form-input
              id="FAQ-category-title"
              v-model="form.title"
              :state="validateState('title')"
            />
            <b-form-invalid
              id="input-title-feedback"
              :label="$t('general.title')"
              :validator="$v.form.title"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="$t('general.language')"
            label-for="FAQ-category-lang"
          >
            <languageSelector @change-selected-language="changeSelectedLanguage" />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          class="mt-50"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="isSubmit"
            @click="submitForm"
          >
            {{ isSubmit ? $t('general.isSubmit') : $t('general.submit') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="$router.go(-1)"
          >
            {{ $t('general.back') }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
    <!--/ form -->
  </b-card>
</template>
<script>
import {
  BButton,
  BCard,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
} from 'bootstrap-vue'
import BFormInvalid from '@/components/BFormInvalid/index.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import Ripple from 'vue-ripple-directive'
import languageSelector from '@/components/language-selector.vue'
import { required, minLength } from 'vuelidate/lib/validators'
import useFAQCategoryList from './useFAQCategoryList'

export default {
  components: {
    BButton,
    BCard,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalid,
    BRow,
    LayoutLoading,
    languageSelector,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      FAQCategory: {},
    }
  },
  validations: {
    form: {
      title: { required, minLength: minLength(3) },
    },
  },
  created() {
    this.form.lang = 'fa'
  },
  methods: {
    changeSelectedLanguage(selectedLanguage) {
      this.form.lang = selectedLanguage
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    submitForm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }
      const data = { title: this.form.title }
      this.addItem(data, this.form.lang)
    },
  },
  setup() {
    const {
      addItem,
      form,
      isSubmit,
      itemLoading,
    } = useFAQCategoryList()

    return {
      addItem,
      form,
      isSubmit,
      itemLoading,
    }
  },
}
</script>
